export default function Workflow() {
  return (
    <section className="shell workflow" id="how">
      <h2>Simplicity by design.</h2>
      <p>One clear conversion flow with visible boundaries and recoverable states.</p>
      <div className="cards">
        <article className="card">
          <span className="num">01</span>
          <h3>Select files</h3>
          <p>Choose HEIC or HEIF files. Limits are visible before conversion begins.</p>
        </article>
        <article className="card">
          <span className="num">02</span>
          <h3>Configure output</h3>
          <p>Pick JPG, PNG, or PDF. JPG offers a bounded quality choice.</p>
        </article>
        <article className="card">
          <span className="num">03</span>
          <h3>Review results</h3>
          <p>Review individual results and choose the next action for each file.</p>
        </article>
      </div>
    </section>
  )
}
